module.exports = __webpack_public_path__ + "static/media/pic-placeholder-attack.4e2aad3a.svg";